<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small"  @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight-130"
                    style="width: 100%">
                        <el-table-column
                        width="80px"
                            prop="SwipeId"
                            label="Id">
                        </el-table-column>
                        <el-table-column
                        width="70px"
                            prop="Name"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                        width="120"
                            prop="Phone"
                            label="手机">
                        </el-table-column>
                        <el-table-column
                        width="200px"
                            prop="AliTrademanager"
                            label="阿里旺旺">
                        </el-table-column>
                        <el-table-column
                            width="180px"
                            prop="CreateTime"
                            label="反馈时间">
                        </el-table-column>
                        <el-table-column
                            prop="FeedbackText"
                            label="反馈内容">
                        </el-table-column>
                        <el-table-column
                            prop="Reply"
                            label="回复内容">
                        </el-table-column>
                        <el-table-column
                            width="180px"
                            prop="ReplyTime"
                            label="回复时间">
                        </el-table-column>
                        <el-table-column
                            label="是否回复">
                            <template slot-scope="scope">
                                  <el-tag v-if="scope.row.IsReply" size="mini" type="success" effect="dark"> 是 </el-tag>
                                  <el-tag v-else type="danger" size="mini" effect="dark"> 否 </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="100px"
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="发送消息给该刷手" placement="bottom">
                                    <el-button  size="mini" type="primary" @click="sendMsg(scope.row)" icon="el-icon-chat-round" circle></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { swipeGetFeedback,swipeReplyFeedback} from '@/request.js'

export default {
    data(){
        return {
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                pSize:20,
                pIndex:1,
            },
            tableData:[],
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        sendMsg(scope){
            this.$prompt('请填写您要发送的内容', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^.{10,100}$/,
            inputErrorMessage: '长度限制为10-100'
            }).then(({ value }) => {
                swipeReplyFeedback({id:scope.Id ,message:value,swipeId:scope.SwipeId},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '回复成功',
                            type: 'success'
                        });
                        scope.IsReply=true;
                        scope.Reply=value;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });       
            });
        },
        query(){
            this.isLoading=true;
            swipeGetFeedback(this.queryModel,(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>